export const Nowrap = (props) => <span style={{ whiteSpace: 'nowrap' }} {...props} />;
